import React, { useEffect, useMemo, useState } from "react";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { Loading, LoadTable } from "../../Components";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import useProcessData from "../../../CommonFunction/ProcessData";
import { gql, useLazyQuery } from "@apollo/client";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";

const queryFunctionForMarket = (fields) => {
  console.log(fields, "fieldsfields", fields?.join(" "));
  const query = gql`
    query GetLoadBoardData($userInput: SearchInputForLoads, $page: Int = 1, $pageSize: Int = 20) {
      getLoadBoardData(userInput: $userInput, page: $page, pageSize: $pageSize) {
        PageData {
          _id
          ${fields?.join(" ")}
        }
        CurrentPage
        totalLength
      }
    }
  `;
  return query;
};
const queryFunctionForPreferred = (fields) => {
  let f = fields?.join(" ") || "_id";
  const query = gql`
    query GetLoadsBasedOnPreferences($userInput: SearchInputForLoads) {
      getLoadsBasedOnPreferences(userInput: $userInput) {
        ${f}
      }
    }
  `;
  return query;
};

const TMSLoadBoard = () => {
  let statusTab = [{ name: "Market" }, { name: "Preferred" }];
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  console.log(Tab);
  const [Key, setKey] = useState("EMT_Market");
  const dispatch = useDispatch();
  const [Loader, setLoader] = useState(true);
  const [formData, setFormData] = useState([]);

  const [fetchLoadBoardData, { loading: getLoadBoardLoading, error: LoadBoardError, data: LoadBoardData }] =
    useLazyQuery(queryFunctionForMarket([]), {
      fetchPolicy: "network-only",
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
      variables: {
        page: 1,
        pageSize: 20,
        userInput: {
          Current_Latitude: 18.5229448,
          Current_Longitude: 73.867306,
          Is_Live: true,
          My_Lane_Filter: true,
          Private_Network: false,
          Public_Network: true,
        },
      },
      onCompleted: () => {
        setLoader(false);
      },
      onError: () => {
        setLoader(false);
      },
    });

  const [
    fetchLoadsBasedOnPreferences,
    { loading: getLoadsBasedOnPreferencesLoading, error: LoadsBasedOnPreferencesError, data: PreferencesData },
  ] = useLazyQuery(queryFunctionForPreferred([]), {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    variables: {
      userInput: { Is_Live: true, My_Lane_Filter: true, Private_Network: false, Public_Network: true },
    },
    onCompleted: () => {
      setLoader(false);
    },
    onError: () => {
      setLoader(false);
    },
  });

  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "Market" } });
  }, []);

  useEffect(() => {
    console.log("hii");
    if (Tab === "Market") {
      setKey(`EMT_${Tab}`);
      dispatch({ type: "TabData", payload: { tab: "Market" } });
    } else if (Tab === "Preferred") {
      setKey(`EMT_${Tab}`);
      dispatch({ type: "TabData", payload: { tab: "Preferred" } });
    }
  }, [Tab]);

  const config = useMemo(
    () =>
      Tab === "Market"
        ? {
          dataKey: "getLoadBoardData",
          dateKeys: ["createdAt", "updatedAt", "Date"],
          deleteKeys: ["__typename"],
          extraDataKey: "PageData",
        }
        : {
          dataKey: "getLoadsBasedOnPreferences",
          dateKeys: ["createdAt", "updatedAt", "Date"],
          deleteKeys: ["__typename"],
        },
    [Tab]
  );

  const { loading, TableHeaders } = useFetchTableData(
    Tab === "Market" ? queryFunctionForMarket : queryFunctionForPreferred,
    Tab === "Market" ? fetchLoadBoardData : fetchLoadsBasedOnPreferences,
    setLoader,
    Tab === "Market" ? `EMT_Market` : `EMT_Preferred`
  );
  console.log(TableHeaders, "dataYASIM YASIM YASIM");

  useProcessData(
    Tab === "Market" ? LoadBoardData : PreferencesData,
    setFormData,
    config,
    Tab === "Market" ? LoadBoardError : LoadsBasedOnPreferencesError,
    formData
  );

  console.log(PreferencesData, "dataYASIM YASIM YASIM");

  const isLoading = getLoadBoardLoading || getLoadsBasedOnPreferencesLoading || Loader;
  console.log(formData, Tab, LoadBoardData, PreferencesData)
  return (
    <div>
      {/* <div className="HeaderDiv">
        <div>
          <p className="pageTitle">Load Board</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div> */}
      <HeaderDiv title={"Load Board"} TableKey={Key} MoreActions={{Is_Print:false}} />
      <Tabs tabs={statusTab} />
      {isLoading ? (
        <Loading />
      ) : !formData || formData?.length === 0 ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {isLoading && <div className="loader-line-div" />}
          <LoadTable
            data={formData}
            loading={isLoading}
            error={Tab === "Market" ? LoadBoardError : LoadsBasedOnPreferencesError}
            title={"My_Loads"}
            TableHeaders={TableHeaders}
          />
        </>
      )}
    </div>
  );
};

export default TMSLoadBoard;
